<template>
  <v-container>
    <v-row>
      <v-col 
        md="8"
        offset-md="2"
        class="px-12">
        <h2 class="text-center">Nuestras redes</h2>
        <hr class="hr-w my-8 bg-red">
        <v-row>
          <v-col
          class="px-0 d-none d-md-block"
          cols="12"
          v-for="(item,i) in items"
          md="4"
          :key="i">
            <img class="img-fluid" contain max-height="100%" :src="item.src">
          </v-col>
        </v-row>
        <div class="d-flex align-center o-hidden">
          <iframe class="mx-auto" src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2Fkefuri.cl%2F&tabs=timeline&width=500&height=300&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId" width="500" height="300" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowTransparency="true" allow="encrypted-media"></iframe>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'SocialNetwork',
  data() {
    return {
      items: [
        {src: require('../assets/img/rrss1.jpg')},
        {src: require('../assets/img/rrss2.jpg')},
        {src: require('../assets/img/rrss3.jpg')},
      ]
    }
  },

}
</script>

<style lang="sass" scoped>

</style>